import { combineReducers } from "redux";
import toasts from "./toastsReducer";
import loginreducer from  "./LoginReducer";

export const appReducer = combineReducers({
  
  toasts,
  loginreducer
})

export const rootReducer = (state, action) => {
  if (action!=undefined && (action.type === 'UN_AUTH' || action.type === 'PRE_AUTH'||action.type === 'SWITCH' || action.type === 'UN_AUTHORIZED')) {
    state = undefined
  }

  return appReducer(state, action)
}


